/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_TitleInputs */

const en_bot_does_title = /** @type {(inputs: Bot_Does_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What BystepBot does`)
};

const id_bot_does_title = /** @type {(inputs: Bot_Does_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang dilakukan BystepBot`)
};

/**
* | output |
* | --- |
* | "What BystepBot does" |
*
* @param {Bot_Does_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_title = /** @type {((inputs?: Bot_Does_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_title(inputs)
	return en_bot_does_title(inputs)
});